// extracted by mini-css-extract-plugin
export var disabled = "_19-a";
export var hierarchyLinkGray = "_19-4";
export var hierarchyLinkUnderline = "_19-3";
export var hierarchyPrimary = "_19-0";
export var hierarchySecondary = "_19-1";
export var hierarchyTertiary = "_19-2";
export var pressed = "_19-6";
export var themeAction = "_19-5";
export var themeDestructive = "_19-8";
export var themeNormal = "_19-7";
export var themeSuccess = "_19-9";